import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import { ResourceType } from '../../../types/resource';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import { BiData } from '@wix/da-bi/pkg/events';
export const OrderCommissionButton = ({ deviation, className })=>{
    var _deviation_commission, _deviation_commission1, _deviation_commission2;
    const { t } = useTranslation();
    var _deviation_commission_isActive;
    const isOpen = (_deviation_commission_isActive = (_deviation_commission = deviation.commission) === null || _deviation_commission === void 0 ? void 0 : _deviation_commission.isActive) !== null && _deviation_commission_isActive !== void 0 ? _deviation_commission_isActive : false;
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const checkoutLink = ((_deviation_commission1 = deviation.commission) === null || _deviation_commission1 === void 0 ? void 0 : _deviation_commission1.subproductId) ? Url.checkoutLink((_deviation_commission2 = deviation.commission) === null || _deviation_commission2 === void 0 ? void 0 : _deviation_commission2.subproductId) : undefined;
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement(ActionBarB18Link, {
        disabled: !isOpen,
        biData: BiData({
            evid: 293,
            typeid: ResourceType.COMMISSION,
            itemid: get(deviation, 'commission.commissionId'),
            points: get(deviation, 'commission.pointsCost'),
            creatorid: get(deviation, 'author.useridUuid')
        }),
        onClick: restrictToLoggedIn(ReferralType.ACTION_BAR, ()=>{
            if (checkoutLink) window.location.href = checkoutLink;
        }, checkoutLink, LoggedOutReturnType.JOIN_ONLY)
    }, t(isOpen ? 'actionbar.orderCommission' : 'actionbar.closedCommission')));
};
OrderCommissionButton.displayName = 'OrderCommissionButton';
export default OrderCommissionButton;

//# sourceMappingURL=OrderCommissionButton.js.map